<template>
    <oss-dialog
        v-model="dialog"
        :key="reload"
        title="Factures de vente CSV et EXCEL"
        valid-title="Importer"
        :actions="importActions"
        :validLoading="loadingValidate"
    >
        <SalesInvoiceImport
            ref="importComponent"
            :actions="importActions"
            :documentType="'SALES_INVOICE'"
            :selectedCompanyId="companyId"
            @documentImported="onDocumentImported()"
        />
        <!-- <template v-slot:actions>

            <v-btn
                v-if="wizardStep === 0"
                :disabled="loading || !fileName"
                elevation="0"
                color="secondary"
                block
                 size=“x-large”
                class="rounded-lg gradient"
                @click="next()"
            >
                Suivant
            </v-btn>

            <v-btn
                v-else
                :disabled="loading"
                elevation="0"
                color="secondary"
                block
                 size=“x-large”
                class="rounded-lg gradient"
                @click="valid()"
            >
                Valider
            </v-btn>
        </template> -->
    </oss-dialog>
</template>

<script lang="ts">
import csvtojson from "csvtojson";

import UploadDocuments from "./document/UploadDocuments.vue";
import SalesInvoiceImport from "./import/SalesInvoiceImport.vue";
import { DialogAction } from "../services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        UploadDocuments,
        SalesInvoiceImport,
    },
    emits: ["salesInvoiceImported"],
})
export class SalesInvoice extends Vue {
    @Model({ type: Boolean }) value: Boolean;

    /* ===== Variables ===== */

    /* --- Variables traitement du fichier --- */

    importActions = {
        action: new DialogAction(),
    };

    columnIsSet = {
        tva1: false,
        tva2: false,
        tva3: false,
    };

    // Event upload du fichier
    loadingValidate: boolean = false;

    // Largeur de la fenetre par defaut
    loading = false;

    reload = 0;
    /* --- Generals values --- */

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    wizardStep = 0;

    /* ===== Fonctions ===== */

    async getJson(str: string) {
        const result = await csvtojson().fromString(str);
        //debugger
        // result = result.map(x => ({
        //     invoiceNumber: x.invoiceNumber,
        //     date: x.date,
        //     companyName: x.companyName,
        //     siret: x.siret,
        //     vatRate: x.vatRate,
        //     netAmount: x.netAmount,
        //     vatAmount: x.vatAmount,
        //     grossAmount: x.grossAmount,
        //     creditNote: x.creditNote,
        //     vatType: x.vatType
        // }))
        return result;
    }

    /**
     * Reset de la fenetre
     */

    reset() {
        this.dialog = false;
    }

    /**
     * Fermeture de la fenetre
     */

    close() {
        this.reset();
        this.dialog = false;
    }

    /* --- VALIDATION --- */

    onDocumentImported() {
        this.$emit("salesInvoiceImported");
    }
}

export default toNative(SalesInvoice);
</script>

<style scoped lang="scss">
.v-badge {
    .badge {
        font-size: 9px;
        font-weight: bold;
    }
}

.v-badge__badge {
    border-radius: 10px;
    margin-right: -10px !important;
    width: 30px;
    height: 20px;
}
</style>
